import { LuSearch } from "react-icons/lu"
import { ImSpinner2 } from "react-icons/im"

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  isPending?: boolean
}

export function SearchFilter({ value, onChange, placeholder = "Поиск...", isPending }: Props) {
  return (
    <div className="p-m border-b bg-card">
      <div className="flex items-center gap-s bg-background border border-primary/30 focus-within:ring-1 focus-within:ring-primary shadow-sm rounded-md transition-colors p-s px-3">
        {isPending ? (
          <ImSpinner2 className="size-icon-m text-secondary-foreground shrink-0 animate-spin" />
        ) : (
          <LuSearch className="size-icon-m text-secondary-foreground shrink-0" />
        )}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent outline-none text-base"
        />
      </div>
    </div>
  )
}
